import { Injectable } from '@angular/core';
import { HttpService } from 'src/app/utils/http-service.service';

@Injectable({
  providedIn: 'root'
})
export class EmitirDeclaracoesService {

  constructor(private service: HttpService) {}

  consultarSituacao(servidorId: number) {
    return this.service.sendGet('tac/declaracao/consultar-situacao', { servidorId });
  }

  previewDeclaracao(data: any) {
    return this.service.sendGet('tac/declaracao/preview', data, 'text');
  }

  downloadDeclaracao(data: any) {
    return this.service.sendGet('tac/declaracao/download', data);
  }
}
